import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ConnectableAccount } from 'api/clients/IntegrationAuthsClient'
import { useMemo } from 'react'
import { MetaAdsAccounts, MetaAdsAdAccount, MetaAdsFacebookPage, MetaAdsInstagramAccount } from './Types'

export const useMetaAdsAccounts = (connectableAccounts: ConnectableAccount[] = []): MetaAdsAccounts => {
  const adAccounts = useMemo<MetaAdsAdAccount[]>(() => {
    return connectableAccounts
      .filter((account) => account.provider === ExternalIntegrationEnum.MetaAds)
      .map((account) => ({
        ...account,
        provider: ExternalIntegrationEnum.MetaAds,
        account_type: 'ad_account',
        additional_data: account.additional_data ?? {},
      }))
  }, [connectableAccounts])

  const facebookPages = useMemo<MetaAdsFacebookPage[]>(() => {
    return connectableAccounts
      .filter((account) => account.provider === ExternalIntegrationEnum.Facebook)
      .map((account) => ({
        ...account,
        provider: ExternalIntegrationEnum.Facebook,
        account_type: 'page',
        additional_data: account.additional_data ?? {},
      }))
  }, [connectableAccounts])

  const instagramAccounts = useMemo<MetaAdsInstagramAccount[]>(() => {
    return connectableAccounts
      .filter((account) => account.provider === ExternalIntegrationEnum.Instagram)
      .map((account) => ({
        ...account,
        provider: ExternalIntegrationEnum.Instagram,
        account_type: 'profile',
        additional_data: account.additional_data ?? {},
      }))
  }, [connectableAccounts])

  return {
    adAccounts,
    facebookPages,
    instagramAccounts,
  }
}
